/* =====================================================================
   SPORTIVOO — JS del tema Shopify
   UI: drawer menu/carrello, marquee, filtri collezione, galleria/qty PDP.
   CARRELLO REALE via Shopify Cart API (/cart.js, /cart/add.js, /cart/change.js).
   ===================================================================== */
(function () {
  'use strict';

  var FREE_SHIP = 5500; // soglia spedizione gratuita in centesimi (€55)
  var MONEY = function (cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); };

  /* ---------- overlay / drawer ---------- */
  var overlay;
  function ensureOverlay() {
    overlay = document.querySelector('.spv-overlay');
    if (!overlay) { overlay = document.createElement('div'); overlay.className = 'spv-overlay'; document.body.appendChild(overlay); }
    overlay.addEventListener('click', closeAll);
  }
  function openDrawer(sel) {
    var d = document.querySelector(sel);
    if (!d) return;
    d.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeAll() {
    document.querySelectorAll('.spv-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'spv-toast'; document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<span class="spv-dot"></span>' + msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2200);
  }

  /* ---------- CARRELLO REALE (Cart API) ---------- */
  function cartLineHTML(item) {
    var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2') + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:10px" />' : '';
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : (item.product_type || '');
    return '' +
      '<div class="spv-cartline">' +
        '<div class="spv-cartline__media spv-ph" style="width:72px;height:72px;flex:none;border-radius:10px;overflow:hidden">' + img + '</div>' +
        '<div>' +
          '<div class="spv-cartline__name">' + item.product_title + '</div>' +
          '<div class="spv-cartline__meta">' + variant + '</div>' +
          '<div class="spv-qty" data-key="' + item.key + '">' +
            '<button data-act="dec" aria-label="Diminuisci">–</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button data-act="inc" aria-label="Aumenta">+</button>' +
          '</div>' +
        '</div>' +
        '<div style="text-align:right">' +
          '<div class="spv-cartline__price">' + MONEY(item.final_line_price) + '</div>' +
          '<button class="spv-cartline__remove" data-remove="' + item.key + '">Rimuovi</button>' +
        '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    if (!cart || !cart.items) return; // risposta non valida (es. errore API): non rompere il drawer
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    var body = document.querySelector('[data-cart-body]');
    if (body) {
      if (!cart.item_count) {
        body.innerHTML = '<div class="spv-cart-empty"><p style="font-family:var(--spv-font-head);font-size:18px;color:var(--spv-ink);margin-bottom:8px;">Il carrello è vuoto</p><p>Aggiungi i tuoi essenziali per allenarti ovunque.</p></div>';
      } else {
        body.innerHTML = cart.items.map(cartLineHTML).join('');
      }
    }
    document.querySelectorAll('[data-ship]').forEach(function (w) {
      var fill = w.querySelector('.spv-ship__fill');
      var label = w.querySelector('[data-ship-label]');
      var pct = Math.min(100, (cart.total_price / FREE_SHIP) * 100);
      if (fill) fill.style.width = pct + '%';
      if (label) {
        if (cart.total_price >= FREE_SHIP) label.innerHTML = '🎉 Hai la <strong>spedizione gratuita</strong>!';
        else label.innerHTML = 'Ti mancano <strong>' + MONEY(FREE_SHIP - cart.total_price) + '</strong> alla spedizione gratuita';
      }
    });
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) { el.textContent = MONEY(cart.total_price); });
    var foot = document.querySelector('[data-cart-foot]');
    if (foot) foot.style.display = cart.item_count ? '' : 'none';
  }

  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { return fetchCart().then(renderCart); }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      if (r.ok) return r.json();
      // errore (es. 422 oltre disponibilità): avvisa e RIENTRA SEMPRE su un carrello valido
      return r.json().then(function (err) { toast((err && err.description) || 'Quantità non disponibile'); }, function () {})
        .then(fetchCart);
    }).catch(fetchCart); // errore di rete → stato reale
  }

  /* ---------- delega eventi: aggiungi / drawer ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) {
      var vid = add.getAttribute('data-variant-id');
      if (!vid) return;
      e.preventDefault();
      var qty = 1;
      var pdp = add.closest('[data-pdp]');
      if (pdp) { var v = pdp.querySelector('[data-pdp-val]'); if (v) qty = Math.max(1, parseInt(v.textContent, 10) || 1); }
      var activeSwatch = pdp && pdp.querySelector('.spv-swatch.is-active[data-variant-id]');
      if (activeSwatch) vid = activeSwatch.getAttribute('data-variant-id');
      add.disabled = true;
      addToCart(vid, qty).then(function () { return refresh(); }).then(function () {
        toast(add.getAttribute('data-name') + ' aggiunto');
        openDrawer('#spv-cart');
      }).catch(function (err) {
        toast((err && err.description) || 'Quantità non disponibile');
        refresh(); // riallinea il drawer allo stato reale
      }).finally(function () { add.disabled = false; });
      return;
    }
    var oc = e.target.closest('[data-open-cart]');
    if (oc) { if (oc.tagName === 'A') e.preventDefault(); openDrawer('#spv-cart'); return; }
    if (e.target.closest('[data-open-menu]')) { e.preventDefault(); openDrawer('#spv-menu'); }
    if (e.target.closest('[data-close-drawer]')) { e.preventDefault(); closeAll(); }

    var qbtn = e.target.closest('.spv-qty button[data-act]');
    if (qbtn) {
      var wrap = qbtn.closest('.spv-qty'); var key = wrap.getAttribute('data-key');
      if (!key) return;
      if (wrap.dataset.busy) return; // ignora click ripetuti mentre la richiesta è in volo
      wrap.dataset.busy = '1';
      var cur = parseInt(wrap.querySelector('span').textContent, 10) || 1;
      var next = qbtn.getAttribute('data-act') === 'inc' ? cur + 1 : cur - 1;
      changeLine(key, Math.max(0, next)).then(renderCart).catch(function () { refresh(); });
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) { changeLine(rm.getAttribute('data-remove'), 0).then(renderCart).catch(function () { refresh(); }); }
  });

  /* ---------- PDP: quantità, swatch, thumbnail ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-pdp-qty]');
    if (q) {
      var wrap = q.closest('[data-pdp]'); var span = wrap.querySelector('[data-pdp-val]');
      var v = parseInt(span.textContent, 10) || 1;
      v += q.getAttribute('data-pdp-qty') === 'inc' ? 1 : -1; if (v < 1) v = 1;
      span.textContent = v;
    }
    var sw = e.target.closest('.spv-swatch');
    if (sw) {
      sw.parentNode.querySelectorAll('.spv-swatch').forEach(function (s) { s.classList.remove('is-active'); s.setAttribute('aria-pressed', 'false'); });
      sw.classList.add('is-active'); sw.setAttribute('aria-pressed', 'true');
    }
    var th = e.target.closest('.spv-pdp__thumb');
    if (th && th.getAttribute('data-img')) {
      th.parentNode.querySelectorAll('.spv-pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      th.classList.add('is-active');
      var main = document.querySelector('.spv-pdp__main');
      if (main) { main.style.backgroundImage = 'url(' + th.getAttribute('data-img') + ')'; main.style.backgroundSize = 'cover'; main.style.backgroundPosition = 'center'; main.removeAttribute('data-label'); }
    }
  });

  /* ---------- marquee ---------- */
  function initMarquee() {
    document.querySelectorAll('.spv-announce__track').forEach(function (tr) {
      if (tr.dataset.dup) return; tr.dataset.dup = '1'; tr.innerHTML = tr.innerHTML + tr.innerHTML;
    });
  }

  /* ---------- collezione: filtri + ordinamento ---------- */
  function initCollection() {
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;
    var chips = [].slice.call(document.querySelectorAll('[data-filter]'));
    chips.forEach(function (btn) {
      btn.addEventListener('click', function () {
        chips.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var f = btn.getAttribute('data-filter'); var shown = 0;
        grid.querySelectorAll('[data-card-cat]').forEach(function (c) {
          var match = (f === 'all' || c.getAttribute('data-card-cat') === f);
          c.style.display = match ? '' : 'none'; if (match) shown++;
        });
        var cnt = document.querySelector('[data-result-count]'); if (cnt) cnt.textContent = shown;
      });
    });
    var sort = document.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', function () {
      var cards = [].slice.call(grid.querySelectorAll('[data-card-cat]')); var v = sort.value;
      cards.sort(function (a, b) {
        var pa = +a.getAttribute('data-card-price'), pb = +b.getAttribute('data-card-price');
        if (v === 'price-asc') return pa - pb; if (v === 'price-desc') return pb - pa; return 0;
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    });
  }

  /* ---------- init ---------- */
  function init() {
    ensureOverlay();
    initMarquee();
    initCollection();
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
